import { useBrowserStorageConsent } from "../context/browser-storage-consent-context";
import { useI18n } from "../context/i18n-context";
import { publicLegalUrl } from "../legal/public-legal-links";
import { presenceStateProps, usePresence } from "./ui/presence";

export function BrowserStorageConsentBanner() {
  const { isBannerOpen, acceptOptionalStorage, rejectOptionalStorage } =
    useBrowserStorageConsent();
  const { language, t } = useI18n();
  const presence = usePresence(isBannerOpen, 240);

  if (!presence.isMounted) return null;

  return (
    <aside
      className="browser-storage-banner"
      {...presenceStateProps(presence.state)}
      aria-labelledby="browser-storage-banner-title"
    >
      <div className="browser-storage-banner__copy">
        <strong id="browser-storage-banner-title">
          {t("browserStorage.title")}
        </strong>
        <p>
          {t("browserStorage.description")}{" "}
          <a href={publicLegalUrl("cookies", language)} target="_blank" rel="noopener noreferrer">{t("browserStorage.learnMore")}</a>
        </p>
      </div>
      <div className="browser-storage-banner__actions">
        <button
          type="button"
          className="btn btn--ghost btn--sm"
          aria-label={t("browserStorage.rejectAria")}
          onClick={rejectOptionalStorage}
        >
          {t("browserStorage.reject")}
        </button>
        <button
          type="button"
          className="btn btn--primary btn--sm"
          aria-label={t("browserStorage.acceptAria")}
          onClick={acceptOptionalStorage}
        >
          {t("browserStorage.accept")}
        </button>
      </div>
    </aside>
  );
}
